var map = {
	"./airbus.png": 5356,
	"./gris-oscuro.jpg": 10087,
	"./iderioja.jpg": 60035,
	"./satelite.jpg": 5835,
	"./street.jpg": 47723,
	"./topografico.jpg": 29065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94460;